exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nps-rating[data-v-6b86dd96] {\n  background-color: #0374d7;\n  text-align: center;\n  border-radius: 50px;\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n  color: white;\n}\n", ""]);

// exports
